import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";

export const StyledContentLoader = styled(ContentLoader)`
  height: 47px;
  width: 280px;
`;

export const TaskLoader = () => (
  <StyledContentLoader height={47} width={280}>
    <rect fill="black" height="9" width="95" x="7" y="12" />
    <rect fill="black" height="9" width="81" x="7" y="28" />
  </StyledContentLoader>
);

export const TaskListLoader = () => (
  <>
    <TaskLoader />
    <TaskLoader />
    <TaskLoader />
  </>
);
